import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu/panel";
import { IncludeCustomPropertyType } from "common/query-builder/query-block/properties-menu/types";
import { Directions } from "common/components/drop-menu/types";
export function template() {
  const position = this.params.position;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-context-menu-wrapper", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.params.open ? /* @__PURE__ */ jsx("div", { sel: ".mp-context-menu", style: position && {
    position: "absolute",
    left: "".concat(position.left, "px"),
    top: "".concat(position.top, "px")
  }, hook: {
    insert: this.helpers.inserted
  } }, /* @__PURE__ */ jsx("style", null, this.helpers.getCss()), /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: this.params.open,
    "experimental-positioning": true,
    direction: Directions.Right
  }, on: {
    change: this.helpers.handleDropMenuChange,
    click: (ev) => ev.stopPropagation()
  }, props: {
    positionParent: this.state.positionParent
  } }, this.state.secondaryAction === "breakdown" ? /* @__PURE__ */ jsx(PropertiesMenuEl, { disabledItems: this.helpers.breakdownDisabledItemsMap(), eventNames: [this.params.breakdownEvent], open: this.params.open, projectId: this.params.projectId, workspaceId: this.params.workspaceId, includeCustomProperties: IncludeCustomPropertyType.All, showBorrowedProperties: true, descriptionEditDisabled: true, onSelect: this.helpers.handleBreakdownMenuSelect }) : /* @__PURE__ */ jsx(ItemsMenuEl, { sel: ".context-menu-options", attrs: {
    "experimental-positioning": true
  }, on: {
    click: (ev) => ev.stopPropagation(),
    clickItem: this.helpers.handleContextMenuSelect
  }, props: {
    keydownProxyEl: document.body,
    sections: [{
      items: this.helpers.menuItems()
    }]
  } }))) : null);
}
